import { Events, EventBus } from '@/events';
import { version } from '@/helpers/service';
import store from '@/store';

import { init as sentryInit, setUser, replayIntegration } from '@sentry/browser';
import { dedupeIntegration } from '@sentry/integrations';

function attachUser(email) {
  setUser(email ? { email } : null);
}

export function init(app) {
  if (process.env.NODE_ENV === 'production') {
    sentryInit({
      dsn: process.env.MIX_SENTRY_DSN,
      environment: process.env.APP_ENVIRONMENT,
      release: version.packageVersion,

      // Replays
      replaysSessionSampleRate: 0.01,
      replaysOnErrorSampleRate: 1,

      integrations: [
        // TODO put Vue integration back, resolve vue/sentry/uikits version conflicts :(
        // https://docs.sentry.io/platforms/javascript/guides/vue/
        dedupeIntegration(),
        replayIntegration({
          maskAllText: false,
          blockAllMedia: true,
        }),
      ],

      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications.',
        'Non-Error promise rejection captured with value: Object Not Found Matching Id:',
        'Network Error',
        'Failed to fetch',
      ],
      denyUrls: [
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        /^moz-extension:\/\//i,
        /^safari-extension:\/\//i,
      ],
    });

    // Initial user
    attachUser(store.state.settings.userData?.email);

    // Watch for future updates
    EventBus.on(Events.USER_UPDATE, (data) => {
      attachUser(data.username);
    });
  }
}
